/**
 * Summary Hooks
 *
 * Shared React hooks for summary statistics using Convex.
 */

import { useQuery } from 'convex/react';
import { api } from '@have-done/backend/convex/_generated/api';
import { getWeekStart, getToday } from '../utils/date';

/**
 * Get weekly summary for the current week
 */
export function useWeeklySummary() {
  const startDate = getWeekStart(getToday());
  return useQuery(api.summary.weekly, { startDate });
}

/**
 * Get weekly summary for a specific week
 */
export function useWeeklySummaryByDate(startDate: string) {
  return useQuery(api.summary.weekly, { startDate });
}

/**
 * Get overall statistics for the user
 */
export function useOverallSummary() {
  return useQuery(api.summary.overall);
}
